export default {
    listMailSent: [],
    searchFilter: null,
    mode: false,
}